<template>
  <v-data-table
    :headers="headers"
    :items="getCustomerVoices"
    :options.sync="options"
    :items-per-page="getPagination.perPage"
    :server-items-length="getPagination.total"
    :loading="isTableLoading"
    loading-text="Loading... Please wait"
    :footer-props="{
      'items-per-page-options': [6, 12, 18, 24, 30],
    }"
    class="elevation-1"
  >
    <template v-slot:[`item.featured_image`]="{ item }">
      <v-container>
        <img
          v-if="item.featured_image"
          :src="`${baseUrl}/storage/${item.featured_image.path}`"
          :alt="item.file_name"
          width="50%"
        />
      </v-container>
    </template>
    <template v-slot:[`item.created_at`]="{ item }">
      <span>{{ formatDate(item.created_at) }}</span>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-container class="p-2">
        <molecule-save
          :icon="'mdi-pencil'"
          :color="'success'"
          :editCustomerVoice="item"
        />
        <v-btn color="error" fab small dark @click="deleteCustomerVoiceById(item.id)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-container>
    </template>
  </v-data-table>
</template>
<script lang="ts">
import routes from '@/utils/routes'
import moment from 'moment'
import { defineComponent } from 'vue'
import { mapActions, mapGetters } from 'vuex'
import MoleculeSave from './MoleculeSave.vue'
import { deleteMessage } from '@/utils/constants'

export default defineComponent({
  props: {
    search: {
      type: String,
      required: false
    }
  },
  components: { MoleculeSave },
  data () {
    return {
      baseUrl: routes.baseUrl,
      options: {},
      headers: [
        {
          text: 'Website URL',
          value: 'website_type_url',
          width: '200',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Featured Image',
          value: 'featured_image',
          width: '200',
          sortable: false,
          align: 'center'
        },
        { text: 'Title', value: 'title', sortable: false, align: 'center' },
        { text: 'Posted At', value: 'created_at', sortable: false, align: 'center' },
        { text: 'Actions', value: 'actions', sortable: false, align: 'center' }
      ],
      customerVoices: []
    }
  },
  watch: {
    options: {
      async handler (data) {
        this.searchCustomerVoices(data)
      },
      deep: true
    },
    search: {
      async handler (data) {
        this.options = {
          ...this.options,
          page: 1,
          search: data
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      getCustomerVoices: 'customerVoice/getCustomerVoices',
      getPagination: 'customerVoice/getPagination',
      isTableLoading: 'global/isTableLoading'
    })
  },
  methods: {
    ...mapActions({
      fetchCustomerVoices: 'customerVoice/fetchCustomerVoices',
      createCustomerVoices: 'customerVoice/createCustomerVoices',
      deleteCustomerVoice: 'customerVoice/deleteCustomerVoice',
      setTableLoading: 'global/setTableLoading'
    }),
    formatDate: (payload: string): string => {
      return moment(payload).format('LLL')
    },
    async deleteCustomerVoiceById (id: number): Promise<void> {
      if (confirm(deleteMessage) === true) {
        this.setTableLoading(true)
        await this.deleteCustomerVoice(id).finally(() => {
          this.setTableLoading(false)
        })
      }
    },
    async searchCustomerVoices (data: {
      page: number;
      itemsPerPage: number;
      search: string;
    }): Promise<void> {
      const { page, itemsPerPage, search } = data

      if (data) {
        const params = {
          page: page,
          limit: itemsPerPage,
          search: search
        }
        this.setTableLoading(true)
        await this.fetchCustomerVoices(params).finally(() => {
          this.setTableLoading(false)
        })
      }
    }
  }
})
</script>
